import React from "react";
import { useHistory } from "react-router";
import blue from "@mui/material/colors/blue";

import { Link } from "../Link";
import { MATCHING_ROUND_COLORS } from "../MatchingRoundStatus";
import { URL } from "../../constants/navigation";
import { Typography } from "../../UI/Typography";
import { MATCH_DATES_STATUS } from "../../contexts/MatchDatesStatusContext/types";
import { useMatchDatesStatusContext } from "../../contexts/MatchDatesStatusContext/context";
import { SxProps, Theme } from "@mui/material";
import { Box } from "../../UI/Box";

export const MATCH_DATES_STATUS_BANNER_ID = "match-dates-status-banner";

const linkSx: SxProps<Theme> = {
  textDecoration: "underline !important",
  cursor: "pointer",
  color: `${blue.A400} !important`,
};

const generateSxStyles = (status: MATCH_DATES_STATUS): SxProps<Theme> => ({
  backgroundColor: MATCHING_ROUND_COLORS[status].bg,
  color: MATCHING_ROUND_COLORS[status].text,
});

export const MatchDatesStatusBanner = () => {
  const { push } = useHistory();
  const { status } = useMatchDatesStatusContext();

  const handleMatchRulesClick = () => push(URL.MATCH_RULES);

  return (
    <Box id={MATCH_DATES_STATUS_BANNER_ID} zIndex={9}>
      {status === MATCH_DATES_STATUS.MATCHING && (
        <Typography py={0.25} px={3} sx={generateSxStyles(MATCH_DATES_STATUS.MATCHING)}>
          Network currently has at least one Matching Round open for matching.  To review your matching end date, visit the {" "}
          <Link sx={linkSx} onClick={handleMatchRulesClick}>
            Match Rules
          </Link>{" "}
          tab.
        </Typography>
      )}
      {status === MATCH_DATES_STATUS.ACTIVE && (
        <Typography py={0.25} px={3} sx={generateSxStyles(MATCH_DATES_STATUS.ACTIVE)}>
          Network currently has at least one Matching Round open for registration only (no matching activities).  To review your registration or matching dates, visit the {" "}
          <Link sx={linkSx} onClick={handleMatchRulesClick}>
            Match Rules
          </Link>{" "}
          tab.
        </Typography>
      )}
      {status === MATCH_DATES_STATUS.UPCOMING && (
        <Typography py={0.25} px={3} sx={generateSxStyles(MATCH_DATES_STATUS.UPCOMING)}>
          Network currently has at least one Matching Round upcoming for matching.  To review your matching start date, visit the {" "}
          <Link sx={linkSx} onClick={handleMatchRulesClick}>
            Match Rules
          </Link>{" "}
          tab.
        </Typography>
      )}
      {status === MATCH_DATES_STATUS.CLOSED && (
        <Typography py={0.25} px={3} sx={generateSxStyles(MATCH_DATES_STATUS.CLOSED)}>
          Network currently has a Matching Round that recently closed for registration or matching.  To re-open registration or matching, visit the{" "}
          <Link sx={linkSx} onClick={handleMatchRulesClick}>
            Match Rules
          </Link>{" "}
          tab.
        </Typography>
      )}
      {status === MATCH_DATES_STATUS.ARCHIVED && (
        <Typography py={0.25} px={3} sx={generateSxStyles(MATCH_DATES_STATUS.ARCHIVED)}>
          This network currently has no Matching Round with a status of: Upcoming, Active, Matching or Closed.
          To create a new Matching Round, please contact clients@roomsync.com
        </Typography>
      )}
    </Box>
  );
};
